import { api } from '@forbiz/web-kit'
import type {
  CompanyDetailResponse,
  CompanyResponse,
  InviteCompanyMemberRequest,
  InviteUserResponse,
  PointLedgerResponse,
  UpdateMemberRoleRequest,
  UpdateMemberStatusRequest,
  UpdateMyCompanyRequest,
} from '@forbiz/contracts'

/**
 * 기업 관리자 '내 회사' API 클라이언트 (BIZ-64). 세션의 companyId로만 스코프되므로
 * 조회·수정 모두 경로에 회사 식별자가 없다.
 */
export const myCompanyApi = {
  get: () => api.get<CompanyDetailResponse>('/api/my-company'),
  update: (body: UpdateMyCompanyRequest) => api.put<CompanyDetailResponse>('/api/my-company', body),
  inviteMember: (body: InviteCompanyMemberRequest) =>
    api.post<InviteUserResponse>('/api/my-company/members', body),
  setMemberStatus: (userId: number, body: UpdateMemberStatusRequest) =>
    api.put<{ ok: boolean }>(`/api/my-company/members/${userId}`, body),
  setMemberRole: (userId: number, body: UpdateMemberRoleRequest) =>
    api.put<{ ok: boolean }>(`/api/my-company/members/${userId}/role`, body),
  removeMember: (userId: number) =>
    api.del<{ ok: boolean }>(`/api/my-company/members/${userId}`),
  points: () => api.get<PointLedgerResponse>('/api/my-company/points'),
  /** 후불(월청구) 전환 셀프 신청 (BIZ-116). 운영자 승인 후 개방된다. */
  requestPostpaid: () => api.post<{ company: CompanyResponse }>('/api/my-company/postpaid-request', {}),
  uploadPostpaidDoc: (file: File) => {
    const form = new FormData()
    form.append('file', file)
    return api.upload<{ ok: boolean }>('/api/my-company/postpaid-doc', form)
  },
}
